import styled, { css } from 'styled-components';

export const ContentContainer = styled.div`
  ${({ plainPage }) =>
    !plainPage &&
    css`
      min-height: 100vh;
      /** 
      * prevents vertical overflow but allows sticky via 'clip'
      * 'clip' is supported by a majority of browsers now
      * 
      * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/overflow-x#clip}
      *
      * used currently for bleeding carousel images on largest breakpoint in PDPs
      */
      overflow-x: clip;
    `}
`;

export default {};
